export default class FireMetric {
    ag;
    d;
    hr;
    map;
    rg;
    val;
    ver;
    /**
     * Contains calculated value for radar,
     * value in range in between 0 and 1
     */
    gmc;
    constructor({ ag, d, hr, map, rg, val, ver, gmc }) {
        this.ag = ag;
        this.d = d;
        this.hr = hr;
        this.map = map;
        this.rg = rg;
        this.val = val.toFixed(2);
        this.ver = ver;
        this.gmc = gmc;
    }
}
